export const statusButtonText = (value, t) => {
  switch (value) {
    case 1:
      return t("global.save_and_send", "Save and send")
    case 2:
      return t("issuereports.cancel_workorder", "Cancel work order")
    case 3:
      return t("issuereports.cancel_workorder", "Cancel work order")
    case 4:
      return t("global.close_and_complete", "Close and complete")
    default:
      return t("global.save_and_send", "Save and send")
  }
}

export const statusButtonColor = (value) => {
  switch (value) {
    case 1:
      return "primary"
    case 2:
      return "error"
    case 3:
      return "error"
    case 4:
      return "primary"
    default:
      return "primary"
  }
}

export const statusSubText = (value, t) => {
  switch (value) {
    case 1:
      return t(
        "issuereports.when_order_is_sent",
        "Once the order has been sent, you cannot make any changes anymore."
      )
    case 2:
      return t(
        "issuereports.if_you_cancel_the_order",
        "If you cancel the order, a confirmation will be sent to the same email address."
      )
    case 3:
      return t(
        "issuereports.if_you_cancel_the_order",
        "If you cancel the order, a confirmation will be sent to the same email address."
      )
    case 4:
      return t(
        "issuereports.when_you_close_the_order",
        "When you close the order, the status of all resolved error reports is updated."
      )
    case 6:
      return t("issuereports.your_workorder_is_canceled", "Your work order is canceled.")
    default:
      return t(
        "issuereports.when_order_is_sent",
        "Once the order has been sent, you cannot make any changes anymore."
      )
  }
}
